// Role-Based Access Control Rules

export const ROLES = {
  VIEWER: 'viewer',
  REVIEWER: 'reviewer',
  ADMIN: 'admin',
  SUPER_ADMIN: 'super_admin',
  // Legacy support
  SUPERADMIN: 'superadmin',
};

// Permissions by action
export const PERMISSIONS = {
  CREATE_REPORT: [ROLES.ADMIN, ROLES.REVIEWER],
  EDIT_REPORT: [ROLES.ADMIN, ROLES.REVIEWER],
  DELETE_REPORT: [ROLES.ADMIN],
  VIEW_REPORT: [ROLES.VIEWER, ROLES.REVIEWER, ROLES.ADMIN, ROLES.SUPER_ADMIN],
  SAVE_REPORT: [ROLES.ADMIN, ROLES.REVIEWER],
  LOCK_REPORT: [ROLES.ADMIN],
  UNLOCK_REPORT: [ROLES.ADMIN],
  REQUEST_REVIEW: [ROLES.ADMIN, ROLES.REVIEWER],
  UPLOAD_DOCUMENTS: [ROLES.ADMIN, ROLES.REVIEWER],
  DELETE_DOCUMENTS: [ROLES.ADMIN],
  ADD_COMMENT: [ROLES.ADMIN, ROLES.REVIEWER],
  RESOLVE_COMMENT: [ROLES.ADMIN, ROLES.REVIEWER],
  DELETE_COMMENT: [ROLES.ADMIN],
  SIGN_REPORT: [ROLES.ADMIN, ROLES.REVIEWER],
};

// Check if user has permission for a specific action
export const hasPermission = (user, permission) => {
  if (!user || !user.role) return false;
  // Normalize role names
  const normalizedRole = user.role === 'superadmin' ? ROLES.SUPER_ADMIN : user.role;
  return PERMISSIONS[permission]?.includes(normalizedRole) || false;
};

// Navigation permissions by role
export const navigationPermissions = {
  dashboard: [ROLES.ADMIN, ROLES.REVIEWER, ROLES.VIEWER],
  analytics: [ROLES.ADMIN, ROLES.REVIEWER],
  map: [ROLES.ADMIN, ROLES.REVIEWER, ROLES.VIEWER],
  stations: [ROLES.ADMIN, ROLES.REVIEWER, ROLES.VIEWER],
  reports: [ROLES.ADMIN, ROLES.REVIEWER],
  settings: [ROLES.ADMIN],
  users: [ROLES.ADMIN]
};

// Check if user has access to a specific nav item
export const hasAccess = (navItemId, userRole) => {
  const allowedRoles = navigationPermissions[navItemId];
  return allowedRoles ? allowedRoles.includes(userRole) : false;
};

// Get accessible nav items for a role
export const getAccessibleNavItems = (navItems, userRole) => {
  return navItems.filter(item => hasAccess(item.id, userRole));
};

// Role display info
export const roleInfo = {
  [ROLES.SUPER_ADMIN]: {
    label: 'Super Admin',
    color: 'var(--color-danger)',
    description: 'Full system access with super privileges'
  },
  [ROLES.ADMIN]: {
    label: 'Admin',
    color: 'var(--color-danger)',
    description: 'Full system access'
  },
  [ROLES.REVIEWER]: {
    label: 'Reviewer',
    color: 'var(--color-primary)',
    description: 'View and analyze data'
  },
  [ROLES.VIEWER]: {
    label: 'Viewer',
    color: 'var(--color-gray-600)',
    description: 'Read-only access'
  }
};